angular.module('AccountingBoxApp')
  .filter('accountsFilter', function() {
    return function(accounts, search) {

      if (angular.isArray(accounts) && !search) {
          let filtered = accounts.filter(a => a.localCount > 0 || a.globalCount > 0);
          if(filtered.length > 0) {
              return filtered;
          }
      }

      return accounts;
    };
  });
